module.exports = __webpack_public_path__ + "img/a_giro_sx.b3845da8.png";